import { ClientResponse } from './ClientResponse';
export class TextClientResponse extends ClientResponse {
    constructor(value, statusCode) {
        super(value, statusCode);
    }
}
